import Context from "../context/context";
import React, { useContext, useState, useEffect } from 'react';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


function Dates(props){
    const {data} = props;
    const {
        selectedFilters, setSelectedFilters,
        activeFilters, setActiveFilters,
        startDate, setStartDate,
        endDate, setEndDate
    } = useContext(Context);

    const [dateToActive, setDateToActive] = useState(false);

    let min_date = new Date().setHours(0,0,0,0);

    useEffect(() => {
        let selected_filters = selectedFilters.map((selected_filter) => {
            if (selected_filter.name === data.name){
                selected_filter.elements.forEach((element) => {
                    if (element.id === "date_from"){
                        element.value = startDate;
                    }
                    if (element.id === "date_to"){
                        element.value = endDate;
                    }
                })
            }
            return selected_filter;
        });

        setSelectedFilters(
            selected_filters
        )
      }, [startDate, endDate]);


    const handleChange = (date, type ) => {

        let updated_date = new Date(date).setHours(0,0,0,0);

        if (type === "date_from"){
            setStartDate(updated_date);
            if (updated_date > endDate){
                setEndDate("");
            }
        }
        if (type === "date_to"){
            setEndDate(updated_date);
        }


    }

    const openDatePanel = (type) => {
        let active_filters = activeFilters;
        active_filters.active_date_panel = type;

        setActiveFilters(
            {...activeFilters},
            active_filters
        )
    }

    const closeDatePanel = () => {
        let active_filters = activeFilters;
        active_filters.active_date_panel = "";

        setActiveFilters(
            {...activeFilters},
            active_filters
        )
    }


    const formatDate = (timestamp) => {
        let date = "DD/MM/YYYY";
        if (timestamp){
            date = new Date(timestamp).toLocaleDateString(new Date(), { day: 'numeric', month: 'numeric', year: 'numeric', })

        }
        return date;
    }

    const openDateTo = () => {
      setDateToActive(true);
    }

    return (

        <>
            <div className="date-inputs">
                <div className="date-input date-from" >
                    <div className="date-input-label">Select a start date</div>
                    <div className="date-input-button" onClick={() => openDatePanel("date_from")}>
                        <span>{formatDate(startDate)}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M15.8333 3.33301H4.16667L2.5 3.33303V18.333H4.16667H15.8333H17.5V3.33303L15.8333 3.33301Z" stroke="#091F2C" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M13.333 1.66699V5.00033" stroke="#091F2C" strokeWidth="1.5" strokeLinecap="square"/>
                            <path d="M6.66699 1.66699V5.00033" stroke="#091F2C" strokeWidth="1.5" strokeLinecap="square"/>
                            <path d="M2.5 8.33301H17.5" stroke="#091F2C" strokeWidth="1.5" strokeLinecap="square"/>
                        </svg>
                    </div>
                </div>

                <div className="date-input date-to">
                    <div className="date-input-label" onClick={() => openDateTo()}>Add an end date</div>

                    <div className={`date-input-button to ${(dateToActive || endDate != "") ? 'active' : ''}`} onClick={() => openDatePanel("date_to")}>
                    <span>{formatDate(endDate)}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M15.8333 3.33301H4.16667L2.5 3.33303V18.333H4.16667H15.8333H17.5V3.33303L15.8333 3.33301Z" stroke="#091F2C" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M13.333 1.66699V5.00033" stroke="#091F2C" strokeWidth="1.5" strokeLinecap="square"/>
                            <path d="M6.66699 1.66699V5.00033" stroke="#091F2C" strokeWidth="1.5" strokeLinecap="square"/>
                            <path d="M2.5 8.33301H17.5" stroke="#091F2C" strokeWidth="1.5" strokeLinecap="square"/>
                        </svg>
                    </div>



                </div>
            </div>
            <div className={`date-panel ${activeFilters.active_date_panel === "date_from" ? 'active' : ''}`}>
                <button className="filters-back" onClick={() => closeDatePanel()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 9 11" fill="none">
                        <path d="M6 2.5L3 5.5L6 8.5" stroke="#091F2C" strokeWidth="3" strokeLinecap="square"/>
                    </svg>
                    Back to filters
                </button>
                <DatePicker
                    showIcon
                    selected={startDate}
                    minDate={min_date}
                    onChange={(date) => handleChange(date, 'date_from')}
                    inline
                />

                <button className="button  button-white-border reset-date" onClick={() => setStartDate("")}>Reset date</button>

            </div>

            <div className={`date-panel ${activeFilters.active_date_panel === "date_to" ? 'active' : ''}`}>
                <button className="filters-back" onClick={() => closeDatePanel()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 9 11" fill="none">
                        <path d="M6 2.5L3 5.5L6 8.5" stroke="#091F2C" strokeWidth="3" strokeLinecap="square"/>
                    </svg>
                    Back to filters
                </button>
                <DatePicker
                    showIcon
                    selected={endDate}
                    minDate={startDate}
                    onChange={(date) => handleChange(date, 'date_to')}
                    inline
                />
                <button className="button  button-white-border reset-date" onClick={() => setEndDate("")}>Reset date</button>

            </div>




        </>

    );
}


export default Dates;
